import casualPleasure from './casualPleasure.json';
import dk from './dk.json';
import us from './us.json';

export const translation = {
	casualPleasure: { translation: casualPleasure },
	dk: { translation: dk },
	us: { translation: us },
};
